import React, { useState } from 'react';
import { dispatch } from 'nike-re-framejs';
import Avatar from '@/common/components/Avatar';
import { getConfigProperty } from '@/common/oldMobile';
import i18n from '@i18n';
import { Docked, DialogTitle, DialogBody } from '@/ui/dialogs/Dialog';
import PopupNg from '@/ui/PopupNg';

import './AvatarSelector.less';

const avatars = getConfigProperty('avatar.list');

function AvatarSelector({ avatarId }) {
    const [selected, setSelected] = useState(avatarId);
    function onSelect(id) {
        dispatch(['account.userData.avatar', id]);
        PopupNg.dispatcher.close();
    }
    function onClick(id) {
        setSelected(id);
        setTimeout(() => onSelect(id), 500);
    }
    return (
        <Docked>
            <DialogTitle>
                <h2>{i18n('selectAvatar.title')}</h2>
            </DialogTitle>
            <DialogBody>
                <ul className="avatars">
                    {avatars.map(id => (
                        <li key={id} className={id === selected ? 'selected' : null}>
                            <Avatar avatarId={id} onClick={() => onClick(id)} />
                        </li>
                    ))}
                </ul>
            </DialogBody>
        </Docked>
    );
}

export default AvatarSelector;
